import { AnimatePresence, motion } from 'framer-motion';
import { FC } from 'react';
import { UserNote } from 'src/modules/materials/components/MaterialPage/MaterialPageTabs/UserNotesTab/UserNote';
import { UserNoteForm } from 'src/modules/materials/components/MaterialPage/MaterialPageTabs/UserNotesTab/UserNoteForm';
import { TranslatedItem } from 'src/hooks/directus/useTranslateItem';
import { media } from 'src/styles/designs';
import { makeTransition } from 'src/utils/motion/transitions';
import styled from 'styled-components';
import { NeauviaItem } from 'src/models/directus';
import { useUserNotesQuery } from 'src/modules/user/hooks/useUserNotesQuery';

const FormContainer = styled(motion.div)`
  padding: 12px 0 24px;
  ${media.w.greaterThanOrEqual.desktop} {
    padding: 0 0 32px;
  }
`;

export const UserNotesTab: FC<{
  item: TranslatedItem<NeauviaItem> | undefined;
}> = ({ item }) => {
  const { data: notes } = useUserNotesQuery(item);

  return (
    <motion.div key="notes" {...makeTransition({ fade: true, from: 'top' })}>
      <AnimatePresence initial={false} exitBeforeEnter>
        {item && (
          <>
            <FormContainer>
              <UserNoteForm item={item} />
            </FormContainer>
            {notes?.map((note) => (
              <UserNote key={note.id} item={item} note={note} />
            ))}
          </>
        )}
      </AnimatePresence>
    </motion.div>
  );
};
